import React from 'react';

const context = { marketInfos: { localCountry: null, localCurrency: null, localLanguage: 'en' }, setMarketInfos: () => null };
export default React.createContext(context);
